module.exports = __webpack_public_path__ + "static/media/howItWorks_step4.c3716e90.png";